import React from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import TableView from "../../components/tableView";
import { IColumns, IListFirmwares } from "../../common/types/firmwareTypes";
import { usePermissions } from "../../customHooks/usePermissions";
import { ColumnDef } from "@tanstack/react-table";
import { DataAvailabilityMessages, Status } from "../../common/constants";
import { IListIotAgent } from "../../common/types/iotAgentTypes";
import useManageUpdates from "./useManageUpdates";

const TabContent = ({ isFirmwareUpload }: { isFirmwareUpload: boolean }) => {
  const {
    columns,
    listFirmwaresData,
    listIotAgentsData,
    handleUploadButtonClick,
    handleFileChange,
    errorMessage,
    fileInputRef,
    selectedFile
  } = useManageUpdates(isFirmwareUpload);
  const tableData: IListFirmwares|IListIotAgent = isFirmwareUpload ? listFirmwaresData : listIotAgentsData;
  const { hasPermissions } = usePermissions();
  const isSuperAdmin: boolean = hasPermissions("user.superadmin");
  return (
    <div>
      {isSuperAdmin && (
        <Row className="align-items-top pt-3 pb-3">
          <Col md={2}>
            <Form.Label>
              Upload {isFirmwareUpload ? "Firmware" : "IOT Agent"}
            </Form.Label>
          </Col>
          <Col md={4}>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Control
                type="file"
                ref={fileInputRef}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFileChange(e, isFirmwareUpload)}
              />
              <div>{errorMessage}</div>
            </Form.Group>
          </Col>
          <Col md={2}>
            <div className="upload-file-btn mb-3">
              <Button disabled={!selectedFile} onClick={(e) => handleUploadButtonClick(e, isFirmwareUpload)}>Upload</Button>
            </div>
          </Col>
        </Row>
      )}
      <Col sm={12} className="manageFirmware">
        <div
          className={
            "manage-firmware-table " +
            (!isSuperAdmin ? "firmware-table-admin-role" : "")
          }
        >
          <TableView
            data={tableData}
            columns={columns}
            noDataMessage={
              isFirmwareUpload
                ? DataAvailabilityMessages.NO_FIRMWARE_AVAILABLE
                : DataAvailabilityMessages.NO_IOT_AGENT_AVAILABLE
            }
          />
        </div>
      </Col>
    </div>
  );
};

export default TabContent;
